import ApexCharts from "apexcharts";

const charts = document.querySelectorAll('.chart-container');

if (charts.length) {
    [...charts].forEach(async el => {
        const data = el.getAttribute('data-json');
        const values = JSON.parse(data);
        const options = {
            series: [{
                name: values.name,
                data: values.values,
            }],
            chart: {
                type: 'area',
                height: 350,
                width: '100%',
                redrawOnWindowResize: true,
                zoom: {
                    enabled: false,
                },
                toolbar: {
                    show: false
                },
                defaultLocale: 'en'
            },
            stroke: {
                curve: 'smooth',
                colors: [values.marker],
            },
            fill: {
                colors: [values.marker]
            },
            labels: values.dates,
            xaxis: {
                type: 'datetime',
            },
            yaxis: {
                opposite: true
            },
            legend: {
                horizontalAlign: 'left'
            }
        };
        const chart = new ApexCharts(el, options);
        await chart.render().then(() => {
            window.dispatchEvent(new Event('resize'));
        });
    });
}
